import { createSlice } from "@reduxjs/toolkit";
import { getProduct, getoneProduct, resetProduct, getComments } from "./thunk"; // Import the async thunks

const initialState = {
  products: [],
  comments: [],
  product: null,
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "productSlice",
  initialState,
  reducers: {
    clearResponses: (state) => {
      //   state.loginResponse = null;
      //   state.registerResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getProduct.pending, (state) => {
        state.loading = true;
        state.products = [];
        state.error = null;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
        state.error = null;
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.products = [];
      });
    builder
      .addCase(getoneProduct.pending, (state) => {
        state.product = null;
        state.loading = true;
        state.error = null;
      })
      .addCase(getoneProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
        state.error = null;
      })
      .addCase(getoneProduct.rejected, (state, action) => {
        state.loading = false;
        state.product = null;
        state.error = action.error.message;
      });

    builder.addCase(getComments.fulfilled, (state, action) => {
      state.comments = action.payload;
    });

    builder.addCase(resetProduct.fulfilled, (state, action) => {
      state.loading = false;
      state.product = [];
      state.error = null;
    });
  },
});

export default productSlice.reducer;
